'use client';

import React, { FC } from 'react';

import styled from 'styled-components';

import { FiltersProvider } from '@contexts/Filters';
import { SearchViewModel, TourListViewModel } from '@api/index';
import { SearchURLProvider } from '@api/data-loaders/resource';

import TourListing from './TourListing';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.backgroundColor};
`;

export interface ITourProps {
  resourceType?: string;
  initialTourSSRData: TourListViewModel | null;
  urlSearch?: SearchViewModel;
  is404?: boolean;
}

const TourListingScreen: FC<ITourProps> = ({
  resourceType = 'Tur',
  initialTourSSRData,
  is404,
  urlSearch,
}) => {
  const resource = /cruise/.test(resourceType) ? 'Gemi' : 'Tur';
  return (
    <SearchURLProvider value={urlSearch || null}>
      <FiltersProvider>
        <Container>
          <TourListing
            resourceType={resource}
            initialTourSSRData={initialTourSSRData}
            is404={is404}
          />
        </Container>
      </FiltersProvider>
    </SearchURLProvider>
  );
};

export default TourListingScreen;
